module.exports = __webpack_public_path__ + "img/2.84ea7c64.jpg";